export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input"
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "input"
			},
			{
				prop: "shuizId",
				label: '申报种类',
				type: "select",
				selectval: []
			},
			{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
		],
		searchdata: {
			nsrmc: "",
			nsrsbh: "",
			shuizId: "",
			companyCode: "",
		},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		tableData: [],
		headData: [{
				title: "纳税人名称",
				custom: true,
				prop: "nsrmc",
				width: 160,
				
			},
			{
				title: "纳税人识别号",
				custom: true,
				prop: "nsrsbh",
				width: 160,
				
			},
			{
				title: "公司代码",
				custom: true,
				prop: "companyCode",
				width: 80
			},
			{
				title: "申报税种",
				prop: "sbzl",
				width: 160,
				custom: true,
			},
			{
				title: "报表状态",
				prop: "status",
				custom: true,
				width: 80
			},
			{
				title: "是否报送",
				prop: "sfbs",
				custom: true,
				width: "80"
			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				fixed: "right"
			},
		],
	}
	return obj
}
